<template>
  <div>
    <div v-for="poem in $attrs.poems" :key="poem.name" :class="'poemContainer ' + poem.class">
      <VueShowdown class="poem elevation-12" :markdown="poem.markDown" flavor="github"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueMarkdown',
  beforeCreate: function() {
        document.body.className = 'darkHeader nature';
    }
}
</script>

<style>
.poemContainer.ocean{
  background-image: url("../assets/ocean.png"); 
  background-position: -40px -200px;
}

.poemContainer.rain{
  background-image: url("../assets/rain.jpg"); 
  background-size: cover;
}

.poemContainer.natureShrugs{
  background-image: url("../assets/natureShrugs.jpg"); 
  background-position: center center;
  background-size: cover;
}

.poemContainer.cogitations{
  background-image: url("../assets/cogitations.png"); 
  background-size: cover;
}

.poemContainer.library{
  background-image: url("../assets/library.png");
  background-size: cover;
}

.poemContainer.raven{
  background-image: url("../assets/raven.jpg");
  background-size: cover;
}
</style>